export const FS_EXTERNAL_LINKS = {
  faqLink: 'https://info.mobywatel.gov.pl/pytania-odpowiedzi#podpis-kwalifikowany',
  supportLink: 'https://www.certum.pl/pl/kontakt/',
} as const;
